var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import { MODE } from '@/define/env';
import UserPreviewState from '../../helpers/user/UserPreviewState';
/**
 * @param type
 * @param url
 * @param options
 * @returns {Promise<{headers: any, json: any, body: (Blob|any), status: number}>}
 */
export default (type, url, options) => __awaiter(void 0, void 0, void 0, function* () {
    const { device, headers, isBlob, isObjectUpload, isValidateOnly } = options, fetchOptions = __rest(options, ["device", "headers", "isBlob", "isObjectUpload", "isValidateOnly"]);
    const baseHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    if (!isObjectUpload) {
        if (device) {
            baseHeaders['X-USER-DEVICE'] = device;
        }
        if (UserPreviewState.previewValue) {
            baseHeaders.Preview = UserPreviewState.previewValue;
        }
        if (MODE !== 'PRODUCTION') {
            // basic認証の内容でAuthorizationヘッダを上書きしてしまうので
            document.execCommand('ClearAuthenticationCache', false);
        }
    }
    if (isValidateOnly) {
        baseHeaders['X-VALIDATE-ONLY'] = true;
    }
    const requestHeadersParam = Object.assign(Object.assign({}, baseHeaders), (headers || {}));
    if (requestHeadersParam['Content-Type'] === 'multipart/form-data') {
        delete requestHeadersParam['Content-Type'];
    }
    if (MODE !== 'PRODUCTION') {
        // basic認証の内容でAuthorizationヘッダを上書きしてしまうので
        document.execCommand('ClearAuthenticationCache', false);
    }
    const response = yield axios.request({
        data: fetchOptions.body,
        headers: requestHeadersParam,
        method: fetchOptions.method,
        onUploadProgress: fetchOptions.onUploadProgress,
        responseType: isBlob ? 'blob' : 'json',
        url,
        withCredentials: true,
    });
    const { headers: responseHeaders, status } = response;
    const json = isBlob ? {} : response.data;
    const body = isBlob
        ? new Blob([response.data], { type: response.data.type })
        : response.data;
    return {
        body,
        headers: responseHeaders,
        json,
        status,
    };
});
